import React, { FC, useEffect, useState } from 'react';
import { SiPayModal } from 'utilities/components';
import { __CardToCardVideoModalProps } from './videoModal.interface';

export const CardToCardVideoModal: FC<__CardToCardVideoModalProps> = (props: __CardToCardVideoModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    return (
        <SiPayModal maxWidth={800} isOpen={isOpen} onClose={props.onClose} title="ویدیو راهنما کارت به کارت">
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <video className="absolute top-0 left-0 w-full h-full rounded-lg" controls autoPlay>
                    <source src="https://new.30pay.me/media/help-deposit-IRT.mp4" type="video/mp4" />
                    مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                </video>
            </div>
            <p className="text-center mt-4 text-darkPurple-100">
                در این ویدیو با نحوه انجام تراکنش‌های ارزی به روش کارت به کارت آشنا خواهید شد.
            </p>
        </SiPayModal>
    );
};
